/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Search_Syntax_DescriptionInputs */



/**
* | output |
* | --- |
* | "Narrow the card search with keys like t:unit, d:fury and e<=3, combine them with or and parentheses, and exclude with a minus." |
*
* @param {Help_Article_Search_Syntax_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_search_syntax_description = /** @type {((inputs?: Help_Article_Search_Syntax_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Search_Syntax_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Grenze die Kartensuche mit Schlüsseln wie t:unit, d:fury und e<=3 ein, verknüpfe sie mit or und Klammern und schließe mit einem Minus aus.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Affinez la recherche de cartes avec des clés comme t:unit, d:fury et e<=3, combinez-les avec or et des parenthèses, et excluez avec un moins.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("用 t:unit、d:fury、e<=3 等键缩小卡牌搜索范围，用 or 和括号组合，用减号排除。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("用 t:unit、d:fury、e<=3 等鍵縮小卡牌搜尋範圍，用 or 和括號組合，用減號排除。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("t:unit, d:fury, e<=3 같은 키로 카드 검색을 좁히고, or와 괄호로 조합하며, 빼기 기호로 제외합니다.")
	return /** @type {LocalizedString} */ ("Narrow the card search with keys like t:unit, d:fury and e<=3, combine them with or and parentheses, and exclude with a minus.")
});